<template>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
               
                <div class="form-row">
                    <div class="col-md-11">
                         <h4 class="header-title mb-4"><h4 class="page-title">{{$t('string.msg.alert.header.label.decription')}}</h4></h4>
                    </div>
                    <div class="col-md-1" v-if="items">
                        <h4 class="text-center">{{$t('str.total')}}</h4>
                        <h4 class="text-center" style="color:grey">{{items.length}}</h4>
                    </div>
                </div>
                <p class="sub-header">
                    {{$t('string.msg.alert.admin.label.description')}}
                </p>
                <form>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <select v-model="filters.status" class="form-control">
                                <option :value="null"> {{$t('string.msg.alert.table.status')}}</option>
                                <option value="ACTIVE"> {{$t('string.msg.alert.table.status.active')}}</option>
                                <option value="CLOSED"> {{$t('string.msg.alert.table.status.closed')}}</option>
                            </select>
                        </div>
                    </div>

                    <br/>
                    <div class="d-flex justify-content-between bd-highlight mb-3">
                        <button @click="filter" class="btn btn-success w-20">{{$t('string.msg.form.btn.search')}}</button>
                    </div>
                </form>

                <div class="table-responsive">
                    <table class="table table-centered table-hover mb-0" id="datatable">
                        <thead>
                            <tr>
                                <th class="border-top-0">{{$t('string.msg.alert.table.header.trucker')}}</th>
                                <th class="border-top-0">{{$t('string.msg.alert.table.header.data')}}</th>
                                <th class="border-top-0">{{$t('string.msg.alert.table.header.status')}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-bind:key="item._id" v-for="item in items" class="cursor-pointer" @click="selectItem(item)">
                                <td>
                                    <span>
                                        {{toUpperCase(item.systemUser.firstName+' '+item.systemUser.lastName)}}
                                    </span>
                                </td>
                                <td>
                                    <span>
                                        {{new Date(item.date).toLocaleDateString()}} - {{new Date(item.date).toLocaleTimeString()}}
                                    </span>
                                </td>
                                <td>
                                    <span v-if="item.status == 'ACTIVE' " style="color:red">
                                        {{toUpperCase($t('string.alert.status.active'))}}
                                    </span>
                               
                                    <span v-else-if="item.status == 'CLOSED'">
                                        {{toUpperCase($t('string.alert.status.closed'))}}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Controller from './CrtListAlert';
import Spinner from '../../../components/layout/Spinner';
import Toast from '../../../components/layout/Toast';

export default {
  name: 'ListAlert',
  props: ["valuekey"],
    watch:{
        'valuekey'(){
        }
    },
  components: {
    Spinner,
    Toast,
  },
  data() {
      return {
        errors: [],
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
        items: [],
        filters: {
            status: "ACTIVE"
        }
      }
  },
  methods: Controller.methods,
  created() {
    Controller.init(this);
     
  },
  mounted(){
     
  }
}
</script>

<style>
</style>
